import React from "react";
import '../css/global.css';
import '../css/Technologies.css';

import {
  SiJavascript,
  SiReact,
  SiPython,
  SiDjango,
  SiNextdotjs,
  SiGraphql,
  SiWordpress,
  SiPhp,
  SiHtml5,
  SiCss,
  SiBootstrap,
  SiGit,
  SiGithub,
  SiFigma,
} from "react-icons/si";

import { VscVscode } from "react-icons/vsc";

const technologies = [
  {
    name: "JavaScript",
    icon: SiJavascript,
  },
  {
    name: "React",
    icon: SiReact,
  },
  {
    name: "Python",
    icon: SiPython,
  },
  {
    name: "Django",
    icon: SiDjango,
  },
  {
    name: "Next.js",
    icon: SiNextdotjs,
  },
  {
    name: "GraphQL",
    icon: SiGraphql,
  },
  {
    name: "WordPress",
    icon: SiWordpress,
  },
  {
    name: "PHP",
    icon: SiPhp,
  },
  {
    name: "HTML5",
    icon: SiHtml5,
  },
  {
    name: "CSS3",
    icon: SiCss,
  },
  {
    name: "Bootstrap",
    icon: SiBootstrap,
  },
  {
    name: "Git",
    icon: SiGit,
  },
  {
    name: "GitHub",
    icon: SiGithub,
  },
  {
    name: "Figma",
    icon: SiFigma,
  },
  {
    name: "VS Code",
    icon: VscVscode,
  },
];

const Technologies: React.FC = () => {
    return(
        <section className="technology">
            <div className="container">
              <div className="header-content">
                <span className="sub-heading">Technologies & Tools</span>
                <h3>What I'm Using</h3>
                <div className="section-divider">
                    <svg
                        width="80"
                        height="16"
                        viewBox="0 0 80 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2 8 C8 2, 14 2, 20 8
                            S32 14, 38 8
                            S50 2, 56 8
                            S68 14, 78 8"
                            stroke="#B8E986"
                            strokeWidth="4"
                            strokeLinecap="round"
                            fill="none"
                        />
                    </svg>
                </div>
            </div>
            <div className="row g-4 technology-list">
                {technologies.map((technology) => (
                    <div
                    className="col-6 col-sm-4 col-md-3 col-lg-2"
                    key={technology.name}
                    >
                    <div className="technology-item">
                        {technology.icon({
                        className: "technology-icon",
                        })}

                        <p>{technology.name}</p>
                    </div>
                    </div>
                ))}
                </div>
          </div>
        </section>
    );
}

export default Technologies;